export default {"src":"/_next/static/media/alphabet.1ecb4a10.svg","height":56,"width":56};